// src/hooks/tokenPage/financialValue/useHistoricalReturns.ts

import { useQuery } from "@tanstack/react-query";
import { historicalReturnsQueryOptions } from "@/services/queries/tokenPage/financialValueQueries";
import type { UseHistoricalReturnsResult } from "@/types/tokenDashboard/financialTab";

/**
 * Custom hook to fetch historical returns data for the token
 */
export function useHistoricalReturns(
  tokenId: string
): UseHistoricalReturnsResult {
  const query = useQuery({
    ...historicalReturnsQueryOptions(tokenId),
    enabled: !!tokenId,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
